import React from 'react';
import { useSnackbar } from 'notistack';

import useSnackbarService from './use-snackbar-service-hook';

const ContextObject = {
  showSnackbar: () => {}
};

const SnackbarContext = React.createContext(ContextObject);

const SnackbarProvider = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { showMessage } = useSnackbarService();

  ContextObject.showSnackbar = (options) => {
    showMessage(enqueueSnackbar, options);
  };

  return <SnackbarContext.Provider />;
};

export { SnackbarContext, SnackbarProvider };
